<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ชื่อแบรนด์:</label>
                <input
                  id="proName"
                  name="proName"
                  v-model="proName"
                  type="text"
                  maxlength="450"
                  class="form-control"
                  placeholder="ชื่อแบรนด์"
                />
                <span class="form-text"></span>
              </div>
            </div>

            <div class="col-xl-12">
              <div class="form-group">
                <label>กลุ่มแบรนด์:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      id="proRival"
                      name="proRival"
                      v-model="proRival"
                      type="checkbox"
                      class="form-check-input"
                    />
                    แบรนด์คู่แข่ง
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-xl-3">
              <div class="form-group">
                <label>สถานะ:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      id="proStatus"
                      name="proStatus"
                      v-model="proStatus"
                      type="checkbox"
                      class="form-check-input"
                    />
                    เปิดใช้งาน
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-xl-3">
              <div class="form-group">
                <label>สถานะการทำ PM:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      id="proPMStatus"
                      name="proPMStatus"
                      v-model="proPMStatus"
                      type="checkbox"
                      class="form-check-input"
                    />
                    เปิดใช้งาน (สถานะการทำ PM)
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="submit" class="btn btn-primary" data-dismiss="modal">
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";
import Vue from "vue";
import VueCurrencyInput from "vue-currency-input";
import Vue2Filters from "vue2-filters";

Vue.use(VueCurrencyInput);
Vue.use(Vue2Filters);

export default {
  components: {
    select2,
  },
  data() {
    var self = this;
    return {
      proId: null,
      proName: null,
      proRival: false,
      proStatus: true,
      proPMStatus: false,
    };
  },
  computed: {},
  methods: {
    formSubmit: function(e) {
      let router = this.$router;
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      axios
        .put("/Api/ProductBrand", {
          ProductBrandId: self.proId,
          ProductBrandName: self.proName,
          RivalBrand: self.proRival,
          InActiveStatus: !self.proStatus,
          PmBrand: self.proRival,
        })
        .then(function(response) {
          if (response.data.status) {
            KTApp.unblockPage();
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            //console.log(response);
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
  },
  async mounted() {
    let self = this;

    //set Current Year
    this.bcYear = new Date();
    $(this.$refs.form).validate({
      rules: {
        proName: "required",
      },
      messages: {
        proName: "กรุณาระบุชื่อแบรนด์",
      },
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";

    axios
      .get("/Api/ProductBrand/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          self.proId = response.data.productBrandId;
          self.proName = response.data.productBrandName;
          self.proRival = response.data.rivalBrand;
          self.proStatus = !response.data.inActiveStatus;
          self.proPMStatus = response.data.pmBrand;
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
  },
};
</script>



// WEBPACK FOOTER //
// App/Components/Master/ProductBrand/ProductBrandUpdate.vue